import toPrecision from './to-precision';

export const isNumber = (value) => !Number.isNaN(Number(value));

export {
  toPrecision,
};
